module.exports = __webpack_public_path__ + "img/guide4.73838b97.png";